import DetailsCard from "@/components/cards/detailsCard";
import {useEffect, useRef, useState} from "react";
import Icon from "@mdi/react";
import {mdiChevronDown, mdiChevronUp} from "@mdi/js";
import ButtonLink from "@/components/inputs/buttonLink";
import {useDispatch, useSelector} from "react-redux";
import {GET_OFFER, GET_OFFER_TYPE} from "@/store/slices/offerSlice";
import Events from "@/utils/Events";
import { GET_USER_STEP, GET_USER_TAB, SET_MODAL } from "@/store/slices/appSlice";
import { GET_PAYMENT_DATA } from "@/store/slices/paymentSlice";
import chartbeatConversionEvent from "@/utils/Chartbeat";
import Head from "next/head";
import themes from "@/styles/themes";
import { GET_USER_ADDRESS } from "@/store/slices/userSlice";
import useOfferDetailsVariant from "@/hooks/useOfferDetailsVariant";
import OfferHighlightCard from "@/components/cards/offerHighlightCard";
import buildOfferHighlight from "./offerHighlight";
import buildPrecoAnual from "./precoAnual";
import {logStatsigEvent, STATSIG_DETALHES_VISUALIZADO} from "@/utils/statsig-events";

export default function Detalhes() {
    const endereco = useSelector(GET_USER_ADDRESS)
    const dispatch = useDispatch()
    const current = useSelector(GET_USER_STEP)
    const userTab = useSelector(GET_USER_TAB)
    const [show, SetDetails] = useState(false)
    const oferta = useSelector(GET_OFFER)
    const events = new Events();
    const offer_type = useSelector(GET_OFFER_TYPE)
    const payment = useSelector(GET_PAYMENT_DATA)
    const [begin_checkout, setBegin_checkout] = useState(false)
    const isOfferHighlightVariant = useOfferDetailsVariant()
    const finishStep = offer_type === 'impresso_digital' ? 4 : 3;
    if(!begin_checkout){
        events.trigger('begin_checkout', { 
            item_id: oferta.cd_oferta, 
            item_name: oferta.name,
            price:  oferta.valor?.valor || oferta.valor?.original,
            value: oferta.valor?.valor || oferta.valor?.original
        })
        setBegin_checkout(true);
    }

    useEffect(() => {
        if(window !== undefined) {
            chartbeatConversionEvent('trackPaywallStart', {eventLabel: 'checkout_assine'})
        }
    }, [])

    // Denominador do experimento: quem realmente viu o topo, já com o grupo
    // resolvido. Dispara uma vez por checkout, igual no controle e no teste.
    const detalhesViewLogged = useRef(false)
    useEffect(() => {
        if (isOfferHighlightVariant === null || detalhesViewLogged.current) {
            return
        }

        detalhesViewLogged.current = true
        logStatsigEvent(STATSIG_DETALHES_VISUALIZADO, {
            variant: isOfferHighlightVariant ? 'test' : 'control',
            offer_type: offer_type ?? '',
            cd_oferta: oferta?.cd_oferta ?? ''
        })
    }, [isOfferHighlightVariant, offer_type, oferta?.cd_oferta])

    function textButton() {
        if (!show) {
            return `Detalhes`
        } else {
            return `Veja menos`
        }
    }

    function iconButton() {
        if (!show) {
            return <Icon path={mdiChevronDown} size={1} className={'icon-align'}/>
        } else {
            return <Icon path={mdiChevronUp} size={1} className={'icon-align'}/>
        }
    }

    function getSecao(): string {
        if (current === 1) {
            switch (userTab) {
                case 0: return 'identificacao'
                case 1: return 'identificacao_cadastro'
                case 2: return 'identificacao_logado'
                case 3: return 'restaurar_senha'
                default: return 'identificacao'
            }
        }
        if (current === finishStep) return 'sucesso'
        if (offer_type === 'impresso_digital') {
            if (current === 2) return 'endereco_entrega'
            return payment.forma === 'cc' ? 'pagamento_cartao' : 'pagamento_debito'
        }
        if (offer_type === 'pre_pago') return 'voucher'
        if (offer_type === 'cortesia') return 'cortesia'
        return payment.forma === 'cc' ? 'pagamento_cartao' : 'pagamento_debito'
    }

    const textoEscadinha = oferta?.escadinha?.[endereco.escritorio || 1000]?.a_partir ?? ''
    let legalText = oferta.texto?.legal ?? ''
    
    let priceLabel = oferta?.valor?.label ?? '';
    if (priceLabel && !priceLabel.includes('R$')) {
        priceLabel = `R$ ${priceLabel}`;
    }

    if (oferta?.is_escadinha) {
        legalText = legalText.replace('[TEXTOESCADINHA]', `por ${textoEscadinha}`)

    }
    if (legalText.includes('[PRECO]')) {
        legalText = legalText.replace('[PRECO]', priceLabel ?? '')
    }
    
    const precoAnual = buildPrecoAnual({oferta, priceLabel})
    const mostraParcelas = precoAnual.parcelas !== null

    const offerHighlight = isOfferHighlightVariant
        ? buildOfferHighlight({
            oferta,
            offer_type,
            periodicidade: oferta?.periodicidade ?? null,
            priceLabel,
            precoAnual,
            escritorio: endereco.escritorio || 1000
        })
        : null


    const mostraDestaque = isOfferHighlightVariant === true && offerHighlight !== null
    const mostraControle = !mostraDestaque

    return (<>
        <Head>
            <title>Assine o Estadão - {oferta?.name}</title>
        </Head>
        {mostraDestaque && offerHighlight && (
            <OfferHighlightCard>
                {offerHighlight.planName &&
                    <p className={'plan-name'}>{offerHighlight.planName}</p>}
                <h4 className={'offer-highlight'}>{offerHighlight.highlight}</h4>
                {offerHighlight.extraTier &&
                    <p className={'offer-bonus'}>{offerHighlight.extraTier}</p>}
                {offerHighlight.bonus &&
                    <p className={'offer-bonus'}>{offerHighlight.bonus}</p>}
                {offerHighlight.renew &&
                    <p className={'offer-renew'}>{offerHighlight.renew}</p>}
                {offerHighlight.showCancel &&
                    <p className={'offer-cancel'}>Cancele quando quiser</p>}
            </OfferHighlightCard>
        )}
        {mostraControle && <DetailsCard>
            <p className={'sm-call-action'}>Assinatura Escolhida</p>
            <h3 className={'offer-title'}>{oferta?.name?.toString().toUpperCase()}</h3>
            <h4 className={mostraParcelas ? 'offer-value anual' : 'offer-value'}>
                {mostraParcelas
                    ? `${precoAnual.parcelas}x de ${precoAnual.parcelaLabel}`
                    : <>{priceLabel}{!precoAnual.ehPlanoAnual && <span>{oferta?.valor?.periodo}</span>}</>}
            </h4>
            {show && current != finishStep ? (<div>
                {oferta?.is_escadinha && !oferta?.has_partner && 
                <p className={'stair-info'}>
                   * {textoEscadinha} <br/>
                </p>}
                <p className={'text-cancel'}>
                    Cancele quando quiser
                </p>
                { current != 3 &&
                    <p className={'change-plan'}>
                        <a 
                            href="https://ofertas.estadao.com.br/" 
                            onClick={()=> {
                                events.trigger("detalhes_oferta_alterar_plano", { offer_type })
                            }}
                        >Alterar plano</a> 
                    </p> 
                }

                <p className={'text-legal'} dangerouslySetInnerHTML={{ __html: legalText }} >
                </p>
                <p className={'text-access'}>
                    {oferta.texto && oferta.texto.acesso}
                    <br/>
                    <span className={'text-summary'} onClick={() => {
                        dispatch(SET_MODAL({type: "sumario", show: true, bg:'#828282' }))
                        events.trigger("detalhes_oferta_sumario_do_contrato", { offer_type })
                    }}>Sumário do Contrato</span>
                </p>
            </div>) : ''}
            {current != finishStep && 
                <ButtonLink onClick={() => {
                    SetDetails(!show)
                    events.trigger("detalhes_oferta_abrir", { show: !show, offer_type, secao: getSecao() })
                }} className={'show-details'} color={themes.greyDark}>{textButton()}{iconButton()}
                </ButtonLink>
            }

        </DetailsCard>}
    </>)
}